<template>
  <div id="app">
    <!-- 路由匹配的组件（包括 PcPage、MobilePage、PrivatePolicy）都在这里渲染 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>